import type { ReactNode } from 'react';
import styles from './FilterChip.module.scss';

type FilterChipSize = 'sm' | 'md';

export interface FilterChipProps {
  children: ReactNode;
  isSelected?: boolean;
  showCheckmark?: boolean;
  onClick?: () => void;
  size?: FilterChipSize;
  disabled?: boolean;
  className?: string;
}

function CircleRing(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function CheckedCircle(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="12" className="circle" />
      <path d="M9.5 16.2 5.8 12.5l1.4-1.4 2.3 2.3 5.3-5.3 1.4 1.4z" className="checkmark" />
    </svg>
  );
}

export function FilterChip({
  children,
  isSelected = false,
  showCheckmark = true,
  onClick,
  size = 'md',
  disabled = false,
  className = '',
}: FilterChipProps): JSX.Element {
  const concatenatedClassName =
    `${styles.chip} ${size === 'sm' ? styles.chip_small : ''} ${className}`.trim();

  return (
    <button
      type="button"
      className={concatenatedClassName}
      aria-pressed={isSelected}
      onClick={onClick}
      disabled={disabled}
    >
      {showCheckmark && (
        <span className={styles.icon} aria-hidden="true">
          {isSelected ? <CheckedCircle /> : <CircleRing />}
        </span>
      )}
      {children}
    </button>
  );
}
